"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = void 0;
/**
 * Global flags that toggle debug features. Example usage:
 *
 * ```
 * import {debug} from "ff-canvas/dist/debug";
 *
 * debug.SHOW_BOUNDS = true;
 * debug.ADD_SUBCANVASES_TO_DOM = true;
 * ```
 */
exports.debug = {
    /**
     * Show every object's bounds as a red dashed outline. Recommended for testing snap-to-grid like features.
     */
    SHOW_BOUNDS: false,
    /**
     * Append each new subcanvas to {@code document.body} for inspection. Useful for ff-canvas development.
     */
    ADD_SUBCANVASES_TO_DOM: false
};
//# sourceMappingURL=debug.js.map